import { Box, Drawer, IconButton, Backdrop, Typography, Divider } from '@mui/material'
import Icon from 'src/@core/components/icon'
import Autocomplete from 'src/layouts/components/Autocomplete'
import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'
import NotificationDropdown from 'src/@core/layouts/components/shared-components/NotificationDropdown'
import { useAuth } from 'src/hooks/useAuth'
import { useState, useCallback, useContext, useEffect } from 'react'
import PopupNotification from 'src/views/components/popUpNotification'
import ClientLoginStatus from 'src/views/login/clientLoginStatus'
import { AuthContext } from 'src/context/AuthContext'
import SideBarContent from './SidebarContent'


const AppBarContent = props => {
  const { hidden, settings, toggleNavVisibility } = props
  const { notificationMessage, openPopUp, setOpenPopUp } = useContext(AuthContext)
  const auth = useAuth()
  const [open, setOpen] = useState(false)
  const [switchingClientName, setSwitchingClientName] = useState(null)

  useEffect(() => {
    const clientName = sessionStorage.getItem('switchingToClient')
    if (clientName) {
      setSwitchingClientName(clientName)
      document.documentElement.style.visibility = ''
      const timer = setTimeout(() => {
        sessionStorage.removeItem('switchingToClient')
        setSwitchingClientName(null)
      }, 4000)
      return () => clearTimeout(timer)
    }
  }, [])

  const toggleDrawer = state => () => {
    setOpen(state)
  }
  const handleClose = useCallback(() => {
    setOpenPopUp(false)
  }, [setOpenPopUp])

  return (
    <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
        {hidden && !settings.navHidden ? (
          <IconButton color='inherit' sx={{ ml: -2.75 }} onClick={toggleNavVisibility}>
            <Icon icon='mdi:menu' />
          </IconButton>
        ) : null}
      </Box>

      <Box
        className='actions-right'
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
      >
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          '@media (max-width: 1600px)': {
            gap: 1
          }
        }}>
          {auth.user && <Autocomplete hidden={hidden} settings={settings} />}

          {auth.user && (
            <>
              <NotificationDropdown settings={settings} />
              <UserDropdown settings={settings} />

              <PopupNotification
                message={notificationMessage}
                open={openPopUp}
                handleClose={handleClose}
              />
            </>
          )}
        </Box>

        <Divider
          orientation='vertical'
          flexItem
          sx={{
            mx: 4,
            my: 1,
            borderColor: 'rgba(255,255,255,0.3)',
            '@media (max-width: 1600px)': { mx: 2 }
          }}
        />

        <Box
          sx={{
            minWidth: '100px',
            display: 'flex',
            alignItems: 'center',
            color: 'white',
            '@media (max-width: 1600px)': { minWidth: 'auto' }
          }}
          onClick={toggleDrawer(true)}
        >
          <ClientLoginStatus />
          <Icon icon='mdi:chevron-down' style={{ marginLeft: '1px' }} />
        </Box>

        <Backdrop
          open={!!switchingClientName}
          sx={{ zIndex: 9999, flexDirection: 'column', gap: 4, backgroundColor: 'rgba(255,255,255,1)' }}
        >
          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
            {[0, 0.18, 0.36].map((delay, i) => (
              <Box
                key={i}
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: '50%',
                  backgroundColor: '#337ab7',
                  animationDelay: `${delay}s`,
                  animation: 'clientSwitchBounce 1.1s ease-in-out infinite',
                  '@keyframes clientSwitchBounce': {
                    '0%, 75%, 100%': { transform: 'translateY(0)', opacity: 0.35 },
                    '35%': { transform: 'translateY(-18px)', opacity: 1 }
                  }
                }}
              />
            ))}
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ color: '#444', fontSize: 18, fontWeight: 600, letterSpacing: '1px' }}>
              Switching client to
            </Typography>
            <Typography sx={{ color: '#337ab7', fontSize: 24, fontWeight: 800, mt: 0.5, letterSpacing: '1px' }}>
              {switchingClientName}
            </Typography>
            <Typography sx={{ color: '#888', fontSize: 13, mt: 1.5, letterSpacing: '1px' }}>
              Please wait while we load your workspace...
            </Typography>
          </Box>
        </Backdrop>

        <Drawer
          anchor='right'
          open={open}
          onClose={toggleDrawer(false)}
          PaperProps={{
            sx: { width: 340, borderRadius: '12px 0 0 12px' }
          }}
        >
          <SideBarContent toggleDrawer={toggleDrawer} />
        </Drawer>
      </Box>
    </Box>
  )
}

export default AppBarContent
